import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { classes } from '../CalendarSummary.st.css';
import { BookingDetailsDataHooks } from '../../constants';

export interface DiscountInfoProps {
  discountName?: string;
  showCalculatedAtCheckoutText: boolean;
}

export const DiscountInfo: React.FC<DiscountInfoProps> = ({
  discountName,
  showCalculatedAtCheckoutText,
}) => {
  const { t } = useTranslation();

  if (!discountName) {
    return null;
  }

  return (
    <div
      className={classes.discountRow}
      data-hook={BookingDetailsDataHooks.DISCOUNT_NAME}
    >
      <Text className={classes.discountNameText}>{discountName}</Text>
      {showCalculatedAtCheckoutText && (
        <Text
          className={classes.commonTextStyle}
          data-hook={BookingDetailsDataHooks.DISCOUNT_CALCULATED_AT_CHECKOUT}
        >
          {t('app.calendar.discount-calculate-at-checkout')}
        </Text>
      )}
    </div>
  );
};
